import { render, staticRenderFns } from "./WatchListItemDialog.vue?vue&type=template&id=9d0b53c6"
import script from "./WatchListItemDialog.vue?vue&type=script&lang=js"
export * from "./WatchListItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports